import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconAlimentos(props) {
    return (
        <svg
            width={243}
            height={243}
            viewBox="0 0 243 243"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M174.64 113.64v-13.8h-30.83V69.01H102.7V56.67h-37V69h-8.22v115.11h127.45v-54.04l-10.29-16.43zm-2.06 4.47l6.57 10.51h-13.14l6.57-10.51zm0 56.58l5.31 5.32h-10.63l5.32-5.32zm2.06-3.75v-29.98h-4.11v29.98l-6.17 6.17v-44.37h6.17v4.11h4.11v-4.11h6.17v44.37l-6.17-6.17zm-4.11-58.76h-43.17v-8.22h43.17v8.22zm-39.06-12.34v-4.11h-4.11v4.11h-4.11v13.71l-4.11 5.48v-43l8.22 8.22v7.37h4.11v-7.37l8.22-8.22v23.82h-8.22v-.01zm-20.55 57.56H61.58v-53.45h53.45v20.56l-4.11 5.48v27.41zm18.5-76.91l-7.37-7.37h14.74l-7.37 7.37zM98.58 69.01h-4.11v-8.22h4.11v8.22zm-20.56-8.22h4.11v8.22h-4.11v-8.22zm8.23 0h4.11v8.22h-4.11v-8.22zm-16.45 0h4.11v8.22H69.8v-8.22zm-8.22 12.33h53.45v26.72H61.58V73.12zm0 88.39h49.34v18.5H61.58v-18.5zm53.45-30.15l11.3-15.07h42.54l-8.63 13.8v49.92h-45.22v-48.65h.01z"
                fill="#000000"
                stroke="#000000"
                strokeWidth={0.75}
                strokeMiterlimit={10}
            />
            <path
                d="M119.14 173.84h37v-37h-37v37zm32.89-4.11h-28.78v-28.78h28.78v28.78z"
                fill="#000000"
                stroke="#000000"
                strokeMiterlimit={10}
            />
            <path
                d="M137.64 165.62c4.54 0 8.22-3.69 8.22-8.22 0-1.76-.58-3.51-1.64-4.93l-6.58-8.77-6.58 8.77a8.292 8.292 0 00-1.64 4.93c-.01 4.53 3.68 8.22 8.22 8.22zm-3.29-10.69l3.29-4.38 3.29 4.38c.53.71.82 1.59.82 2.47a4.11 4.11 0 11-8.22 0c0-.88.29-1.76.82-2.47zM106.8 112.18h-37v4.11h37v-4.11zM69.8 140.96h37V120.4h-37v20.56zm4.11-16.45h28.78v12.33H73.91v-12.33zM106.8 145.07h-37v4.11h37v-4.11z"
                fill="#000000"
                stroke="#000000"
                strokeMiterlimit={10}
            />
            <path
                d="M121.2 242.41C54.38 242.41 0 188.04 0 121.21 0 54.39 54.38 0 121.2 0c66.84 0 121.2 54.38 121.2 121.21-.01 66.83-54.37 121.2-121.2 121.2zm0-235.64C58.11 6.77 6.77 58.11 6.77 121.2c0 63.1 51.34 114.43 114.43 114.43S235.63 184.3 235.63 121.2C235.62 58.11 184.29 6.77 121.2 6.77z"
                fill="#000000"
            />
            <path
                d="M181.4 36.94c0-10.72 8.71-19.4 19.42-19.4 10.72 0 19.4 8.68 19.4 19.4 0 10.7-8.68 19.4-19.4 19.4-10.71 0-19.42-8.7-19.42-19.4z"
                fill="#000000"
            />
            <path
                d="M190.35 36.94c0-5.78 4.67-10.44 10.46-10.44 5.8 0 10.45 4.66 10.45 10.44 0 5.76-4.65 10.44-10.45 10.44-5.79 0-10.46-4.68-10.46-10.44z"
                fill="#FFDD00"
            />
        </svg>
    )
}

export default SvgIconAlimentos;